import { useEffect, useState, useRef, useMemo } from "react";
import { getVideoDownloadMenu, getVideoListMenu } from "@/api/videoPlay";
import { Tree, Layout, Button, Typography, message, Tabs, Empty } from "antd";
import "./index.less";
import { useLocation } from "react-router-dom";
import { CloudDownloadOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { flatMap } from "lodash-es";
import { useNavigate } from "react-router-dom";
import LoginAlertModal from "../components/loginAlertModal";
import { useGetLoginInfo } from "@/hooks/useGetLoginInfo";
import { checkIsLogin } from "@/utils/common";


const { Header, Sider, Content, Footer } = Layout;
const { Text } = Typography;

const videoDetail = (props: any) => {
  const navigate = useNavigate();
  const [videoTreeInfoList, setVideoTreeInfoList] = useState<any>([]);
  const [showLoginAlertModal, setShowLoginAlertModal] = useState<boolean>(false);
  const { authorization, portalAuthorization, goLogin } = useGetLoginInfo();
  const [downloadMenuList, setDownloadMenuList] = useState<{ name: string; file?: any; id: string }[]>([]); //课程附件列表
  const downloadingList = useRef<string[]>([]); //正在下载的列表
  // 当前选择的视频信息
  const [curVideoInfo, setCurVideoInfo] = useState({
    videoUrl: "",
    isLiveTime: false,
  });
  const [expandedKeys, setExpandedKeys] = useState<any>([]);
  const [currentKey, setCurrentKey] = useState<any>("");
  // 默认蒙层海报
  const [curVideoInfoImage, setCurVideoInfoImage] = useState(
    "https://kh-mall.obs.cn-north-1.myhuaweicloud.com/STORE/1846901183449423872/20250103/c883afa8861e4cfea1e26985cfd04163.png"
  );
  const videoRef = useRef<any>(null);

  const location = useLocation(); // 获取当前URL的信息
  const searchParams = new URLSearchParams(location.search);
  const [videoInfo, setVideoInfo] = useState({
    name: "手把手教你做PC",
    categoryDescribe: "KaihongOS 笔记本电脑开发实战系列课程",
  });
  const [flattenVideoInfoList, setFlattenVideoInfoList] = useState<any>([]);
  // 定义一个递归拍平函数
  function flattenChildren(arr: any): any[] {
    return flatMap(arr, (item: any) => {
      const { children, ...rest } = item;
      return [rest, ...flattenChildren(children || [])];
    });
  }

  const getVideoDetailId = () => {
    if ( location.pathname.includes("video/pc") ) {
      if (process.env.NODE_ENV === "development" || (process.env as any).NODE_ENV === "preRelease") {
        return '1873609732724371458'
      }
      return '1873991412916166658'
      
    }
    if ( location.pathname.includes("video/fly") ) {
      if (process.env.NODE_ENV === "development" || (process.env as any).NODE_ENV === "preRelease") {
        return '1878616461749006337'
      }
      return '1878616461749006337'
    }
    return searchParams.get("id");
  }
  
  const id = getVideoDetailId();

  useEffect(() => {
    if (!id) return; // 如果没有id，不进行任何操作
    getVideoListMenu({
      id,
    }).then((res: any) => {
      if (res.code == 200) {
        // 递归格式化数据
        const formatTreeData = (data: any[]): any[] =>
          data.map((item) => ({
            id: item.id,
            selectable: item.children ? false : true,
            name: (
              <div
                className="video-menu-item"
                style={{
                  color: `${item.type === "VIDEO_PLAY" || item.name === "2.2驱动子系统开发流程" ? "rgba(255, 255, 255, 0.7)" : "rgba(255, 255, 255, 1)"}`,
                }}
              >
                <span>{item.name}</span> <span className={`video-play-time ${item.livePlayTime == "直播已结束，视频转码上传中" ? "live-over" : ""}`}>{item.livePlayTime}</span>
              </div>
            ),
            children: item.children ? formatTreeData(item.children) : undefined,
          }));
        const targetVideoList = res.result.children;
        setVideoTreeInfoList(formatTreeData(targetVideoList));

        setFlattenVideoInfoList(flattenChildren(targetVideoList));
        // 递归函数：提取所有 key, 用于展开所有节点
        const getAllKeys = (data: any[]): string[] => {
          return data.reduce((keys: string[], item) => {
            keys.push(item.id); // 添加当前节点的 key
            if (item.children) {
              keys = keys.concat(getAllKeys(item.children)); // 递归处理子节点
            }
            return keys;
          }, []);
        };
        const expandedKeys = getAllKeys(targetVideoList);
        setExpandedKeys(expandedKeys);
        setVideoInfo({
          name: res.result?.name,
          categoryDescribe: res.result?.categoryDescribe,
        });
        setCurVideoInfoImage(res.result?.children[0]?.children[0]?.galleryList?.[0]);
      }
    });
    //获取课程附件列表
    getDownloadMenuList();
  }, [id]); // 这里依赖项为id，当id变化时重新触发

  //切换视频数据
  const handleClickVideo = (item: any) => {
    if (item) {
      // 从拍平的数组中，找到当前高亮的视频地址：flattenVideoInfoList
      const curSelectedVideoInfo = flattenVideoInfoList.find((_: any) => _.id === item.id);
      setCurVideoInfo({
        videoUrl: curSelectedVideoInfo?.videoUrl || "",
        isLiveTime: curSelectedVideoInfo?.isLiveTime,
      });
      setCurVideoInfoImage(curSelectedVideoInfo?.image);
      //播放视频
      videoRef.current?.addEventListener("loadedmetadata", () => {
        videoRef.current.play();
      });
    }
  };

  // 展开/收起节点
  const handleExpand = (expandedKeys: any) => {
    setExpandedKeys(expandedKeys);
  };

  const onSelect = (selectedKeys: any, info: any) => {
    // 获取当前节点的key
    const key: any = selectedKeys?.[0] ?? currentKey;
    if (!key) return;
    const curSelectedVideoInfo = flattenVideoInfoList.find((_: any) => _.id === key);
    if (!curSelectedVideoInfo?.isLiveTime) return window.message.warning("当前视频暂未发布，敬请期待");
    setCurrentKey(key);
    // 判断节点是否已经展开
    const isExpanded = expandedKeys.includes(key);
    // 更新展开的节点keys
    setExpandedKeys(isExpanded ? expandedKeys.filter((k: any) => k !== key) : [...expandedKeys, key]);

    //切换视频
    if (info?.selectedNodes && !info?.selectedNodes?.[0]?.children) {
      handleClickVideo(info.selectedNodes[0]);
    }
  };

  useEffect(() => {
    console.log("videoInfo 1", videoRef);
    if (videoRef.current) {
      console.log("videoRef", videoRef.current);
      videoRef.current.oncontextmenu = function () {
        console.log("禁止右键");
        return false;
      };
    }
  }, [videoRef.current, curVideoInfoImage]);

  const [collapsed, setCollapsed] = useState(false);

  const [introExpanded, setIntroExpanded] = useState(false); // 控制简介是否展开为全屏
  const handlePlay = (e: any) => {
    console.log("video play", e);
    checkTimeStatus(currentPlayTime.current);
  };
  const currentPlayTime = useRef<any>(null);
  const timeout = useRef<any>(null);
  const handleTimeUpdate = (e: any) => {
    console.log("video timeupdate", e.target.currentTime);
    checkTimeStatus(e.target.currentTime);
    currentPlayTime.current = e.target.currentTime;
  };
  const checkTimeStatus = (currentTime: any) => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      if (currentTime >= 2 * 60 && !authorization) {
        videoRef.current.pause();
        setShowLoginAlertModal(true);
        if (document.fullscreenElement) {
          toggleFullScreen();
        }
      }
    }, 200);
  };
  const toggleFullScreen = () => {
    const dom: any = document;
    if (dom?.exitFullScreen) {
      dom.exitFullScreen();
      //兼容Firefox
    } else if (dom.mozCancelFullScreen) {
      dom.mozCancelFullScreen();
      //兼容Chrome, Safari and Opera等
    } else if (dom.webkitExitFullscreen) {
      dom.webkitExitFullscreen();
      //兼容IE/Edge
    } else if (dom.msExitFullscreen) {
      dom.msExitFullscreen();
    }
  };
  /**
   * 课件下载
   * @param file 资源下载地址
   * @param courseId 课程id
   */
  const downloadSource = (file: any, courseId?: any) => {
    const maxFileSize = 1024 * 1024 * 1024; //暂不使用a标签下载
    console.log("file", file.fileSize, courseId);
    countDownload(courseId);
    if (Number(file.fileSize) > maxFileSize) {
      console.log("文件过大");
      downloadingList.current = downloadingList.current.filter((item: any) => item !== courseId);
      return window.open(file.url, "_blank");
    } else {
      fetch(file.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.blob();
        })
        .then((blob) => {
          try {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url); // 释放URL对象
            document.body.removeChild(a); // 移除a标签
          } catch (error) {
            console.error("Error downloading file:", error);
          }
          downloadingList.current = downloadingList.current.filter((item: any) => item !== courseId);
        })
        .catch((error) => {
          console.error("There has been a problem with your fetch operation:", error);
          downloadingList.current = downloadingList.current.filter((item: any) => item !== courseId);
        });
    }
  };
  /**
   *  课程附件下载量统计
   * @param courseId 课程附件id
   */
  const countDownload = (courseId: any) => {
    const myIframe = document.getElementById("hm_iframe_video_detail") as HTMLIFrameElement;
    // 提交统计的 路径规则： videoFile/{当前课程id}/{当前课程附件id}
    const iframeSrc = "download_hit#videoFile/" + id + "/" + courseId;
    if (myIframe.src.includes("download_hit")) {
      myIframe.src = iframeSrc;
      myIframe?.contentWindow?.location.reload();
    } else {
      myIframe.src = iframeSrc;
    }
  };
  const menuTabs: any = useMemo(() => {
    return [
      {
        key: "1",
        label: "目录",
        children: (
          <Layout>
            <Content className="video-menu-box">
              <Tree
                blockNode
                switcherIcon={<div className="collsapse-btn-icon"></div>}
                treeData={videoTreeInfoList}
                expandedKeys={expandedKeys}
                selectedKeys={[currentKey]}
                onExpand={handleExpand}
                onSelect={onSelect}
                fieldNames={{ title: "name", key: "id", children: "children" }}
                style={{ background: "rgba(27, 33, 40, 1)", color: "rgba(255, 255, 255, 1)" }}
              />
            </Content>
          </Layout>
        ),
      },
      {
        key: "2",
        label: "课程附件",
        children: (
          <Layout>
            <Content className="video-menu-box">
              <div className="download-list">
                {downloadMenuList.length > 0 ? (
                  downloadMenuList.map((item, index) => {
                    return (
                      <div className="download-item" key={item?.name + "-" + index}>
                        <div className="download-item-text">{item?.name}</div>
                        {item?.file && item?.file?.url && (
                          <div
                            className="download-item-btn"
                            onClick={() => {
                              if (downloadingList.current.findIndex((i) => i == item?.id) > -1) {
                                window.message.warning("该文件正在下载中，请稍后");
                                return;
                              }
                              downloadingList.current.push(item?.id);
                              checkIsLogin(() => {
                                downloadSource(item?.file, item?.id);
                              });
                            }}
                          >
                            <CloudDownloadOutlined className="download-icon" />
                            立即下载
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <>
                    <div className="download-list">
                      <div className="download-item">当前暂无可下载课程附件</div>
                    </div>
                  </>
                )}
              </div>
            </Content>
          </Layout>
        ),
      },
    ];
  }, [expandedKeys, downloadMenuList, currentKey, videoTreeInfoList]);
  /**
   *  获取课程附件目录
   */
  const getDownloadMenuList = () => {
    getVideoDownloadMenu({ id })
      .then((res: any) => {
        try {
          if (res.code == 200) {
            console.log(res);
            setDownloadMenuList(res?.result);
          }
        } catch (error) {
          console.error(error);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };
  return (
    <>
      <iframe id="hm_iframe_video_detail" style={{ display: "none" }} src=""></iframe>
      <Layout className="video-collection-wrap" style={{ background: "rgba(27, 33, 40, 1)" }}>
        <Layout>
          {/* 左侧视频区域 */}
          <Layout
            style={{
              flexDirection: "column",
              width: collapsed ? "100%" : "70%",
              position: "relative",
            }}
          >
            <div
              style={{
                color: "rgba(15, 98, 254, 1)", // 文字颜色
                padding: "10px", // 内边距
                borderRadius: "0%", // 圆形背景
                position: "absolute",
                display: "inline-block",
                left: 6,
                top: 8,
                cursor: "pointer",
                width: "fit-content",
              }}
              onClick={() => navigate("/videoPlayer")}
            >
              <LeftOutlined />
              <span style={{ paddingLeft: "4px" }}>返回</span>
            </div>
            {/* 视频区域 */}
            <Content className="video-play-wrapper" style={{ background: "#000000" }}>
              {!(Boolean(curVideoInfo?.videoUrl) && curVideoInfo?.isLiveTime) ? (
                <img src={curVideoInfoImage} alt="" className="video-image" style={{ maxWidth: "100%", maxHeight: "100%" }} />
              ) : (
                <video
                  className="video-play-content"
                  onPlay={handlePlay}
                  onTimeUpdate={handleTimeUpdate}
                  controlsList="nodownload"
                  ref={videoRef}
                  src={curVideoInfo?.videoUrl}
                  autoPlay
                  controls
                ></video>
              )}
              {/* 折叠按钮 */}
              <div className={`${collapsed ? "collapse-btn-right" : "collapse-btn-left"} collapse-btn`}>
                <Button
                  type="primary"
                  shape="circle"
                  onClick={() => {
                    setCollapsed(!collapsed);
                  }}
                  icon={
                    collapsed ? (
                      <div className="collapse-btn-icon-left">
                        <LeftOutlined style={{ height: "32px" }} color="rgba(172, 172, 172, 1)" />
                      </div>
                    ) : (
                      <div className="collapse-btn-icon">
                        <RightOutlined style={{ height: "32px" }} color="rgba(172, 172, 172, 1)" />
                      </div>
                    )
                  }
                />
              </div>
            </Content>

            {/* 视频简介区域 */}
            {!collapsed && (
              <Footer
                className="video-footer"
                style={{
                  textAlign: "left",
                  height: introExpanded ? "100%" : "auto",
                  position: introExpanded ? "absolute" : "relative",
                  top: introExpanded ? "0" : "auto",
                  left: "0",
                  right: "0",
                  zIndex: introExpanded ? 100 : "auto",
                  overflowY: "auto",
                  transition: "all 0.3s",
                }}
              >
                <Text className="video-title-name">{videoInfo.name}</Text>
                <br />
                <Text className="video-title-describe">{videoInfo.categoryDescribe}</Text>
              </Footer>
            )}
          </Layout>

          {/* 右侧菜单和内容 */}
          {/* <Layout></Layout> */}
          <Sider
            width="30%"
            collapsible
            collapsedWidth="0"
            collapsed={collapsed}
            trigger={null}
            style={{
              background: "rgba(27, 33, 40, 1)",
              transition: "all 0.3s",
              overflowY: "scroll",
              overflowX: "visible",
            }}
          >
            <Tabs className="video-menu-select-title" defaultActiveKey="1" items={menuTabs} />
          </Sider>
        </Layout>
        {showLoginAlertModal && <LoginAlertModal onClose={() => setShowLoginAlertModal(false)} onOk={() => goLogin()} />}
      </Layout>
    </>
  );
};

export default videoDetail;
